import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface SupportIssuesAlertData {
  fresh: number;
  unresolved: number;
  overdue: number;
}

/** Bottom-left snackbar: "N fresh, M unresolved support issues" with a View CTA. */
@Component({
  selector: 'app-support-issues-alert',
  template: `
    <div class="d-flex flex-row align-items-center" style="cursor: pointer">
      <div class="d-flex flex-column mr-2">
        <h4 class="mb-0"><i class="bi bi-life-preserver mr-1"></i>
          @if (data.fresh > 0) { {{ data.fresh }} fresh support issue{{ data.fresh === 1 ? '' : 's' }} for you, }
          {{ data.unresolved }} unresolved
          @if (data.overdue > 0) { <span class="ml-1">({{ data.overdue }} overdue)</span> }
        </h4>
      </div>
      <button class="ml-2 mr-2" (click)="dismiss()">Dismiss</button>
      <button class="ml-auto" (click)="view()">View</button>
    </div>
  `,
})
export class SupportIssuesAlertComponent {
  constructor(
    private readonly router: Router,
    public snackBarRef: MatSnackBarRef<SupportIssuesAlertComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SupportIssuesAlertData,
  ) {}

  dismiss(): void {
    this.snackBarRef.dismiss();
  }

  view(): void {
    this.snackBarRef.dismiss();
    this.router.navigate(['/salesmax-support/issues'], { queryParams: { scope: 'mine' } });
  }
}
